import store from "../../../store";
import { IConfiguration } from "../../../domain/configuration";
import { IContentSource } from "../../../domain/drawing";
import { IClipboardService, IClipboardAccessible, Dictionary } from "../../../domain/system";
import { UrlSchemeClient } from "../../../utilities";
import { ClipboardAccessor, ClipboardWatcher } from "../../system";
import { ClipboardRepository } from "./ClipboardRepository";

export class ClipboardService implements IClipboardService {
  constructor(private readonly _intervalAsMsec: number) {
  }

  private readonly _repository: ClipboardRepository = new ClipboardRepository();

  createAccessor(): IClipboardAccessible {
    return new ClipboardAccessor(
      new ClipboardWatcher<string>((count, latestSequenceNo) => this._repository.getLatestTexts(count, latestSequenceNo), this._intervalAsMsec),
      new ClipboardWatcher<IContentSource>((count, latestSequenceNo) => this._repository.getLatestImages(count, latestSequenceNo), this._intervalAsMsec)
    );
  }

  async start(): Promise<void> {
    const parameters = new Dictionary<string, string>();
    parameters.set("action", "clipboard");
    const query = parameters.keys.map((key: string) => key + "=" + parameters.get(key)).join("&");
    const config = store.getters.configuration as IConfiguration;
    const url = config.behavior.localhost.schemeUrlPrefix + "?" + query;
    const client = new UrlSchemeClient();
    client.request(url);
  }
}
